import {getAxiosConfig, handleResponse} from 'Shared/utilities/fetchHelpers';
import {getAPIUrl} from './config';
import axiosInstance from 'Shared/utilities/axiosInstance';

export default {
  searchQuotes: async (opportunityNumber: string, customerNumber: string, customerName: string) => {
    const endpoint = `opportunity/search`;
    
    const createPayload = {
      customerName: customerName?.trim(),
      customerNumber: customerNumber?.trim(),
      opportunityNumber: opportunityNumber?.trim(),
    };
    
    const response = await axiosInstance
      .post(getAPIUrl(endpoint), createPayload, {
        ...getAxiosConfig(),
      });
      
      const pagedResponse = {
        currentPageNumber: 0,
        links: [],
        result: response.data,
        totalCount: response.data.length,
      };
      response.data = pagedResponse;
      
      return handleResponse(response);
    },
};
